<template>
  <div class="flex flex-col gap-4 relative">
<!--    <NewsItem />-->
    <div class="flex flex-wrap xl:grid xl:grid-cols-2 gap-4 pt-2">
      <EventItem />
      <PodItem />
    </div>
    <ItemTopics />
    <GaleriaItem />
  </div>
</template>

<script setup>
// import NewsItem from '../components/home/news.vue'
import EventItem from '../components/home/eventos.vue'
import PodItem from '../components/home/podcast.vue'
import GaleriaItem from '../components/home/galeria.vue'
// import ShopItem from '../components/home/shop.vue'
import ItemTopics from '../components/home/topicos.vue'
// import RankingFs from '@/components/home/ranking-fs.vue'
</script>